// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"8a3c4a11","585":"47966dd1"}[chunkId] + ".chunk.js";
};